import React from 'react'
import styled from 'react-emotion'
import Link from 'gatsby-link'
import { mediumMediaQuery } from 'utils/style-helpers'
import Wrapper from 'components/Wrapper'
import LinkButton from 'components/LinkButton'
import { heavyFontFamily } from 'utils/style-helpers'

const Container = styled.div`
  border-top: 2px solid #e0e0e0;
`

const ContentWrapper = styled(Wrapper)`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  padding-bottom: 64px;
  padding-top: 64px;
  margin-bottom: -20px;
  max-width: 933px;

  ${mediumMediaQuery} {
    justify-content: space-between;
    margin-bottom: 0;
  }
`

const Copy = styled.p`
  ${heavyFontFamily()}
  color: #2c2c2c;
  font-size: 18px;
  letter-spacing: 4px;
  margin: 0 15px 20px;
  min-width: 260px;
  text-align: center;
  text-transform: uppercase;

  span {
    color: #4caf50;
    font-size: 32px;
  }

  ${mediumMediaQuery} {
    margin: 0;
  }
`

const ActionButton = styled(LinkButton)`
  margin: 0 15px 20px;
  min-width: 260px;

  ${mediumMediaQuery} {
    margin: 0;
  }
`

const Pricing = () => (
  <Container>
    <ContentWrapper>
      <Copy>Prices starting at <span>&#36;19</span> per month</Copy>
      <ActionButton href="#sign-up">Learn More</ActionButton>
    </ContentWrapper>
  </Container>
)

export default Pricing



// WEBPACK FOOTER //
// ./src/components/Pricing/index.js